import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { TaskFileGroupInterface } from './definitions/task-file-group-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface SetDocumentsMissingResponse {
  taskFileGroup: {
    setDocumentsMissing: {
      output: TaskFileGroupInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class SetDocumentsMissingService {
  constructor(private apollo: Apollo) {}

  setDocumentsMissing(
    taskFileGroupId: string,
    message: string,
    mutation: DocumentNode
  ): Observable<FetchResult<SetDocumentsMissingResponse>> {
    return this.apollo.mutate<SetDocumentsMissingResponse>({
      mutation: mutation,
      variables: {
        id: taskFileGroupId,
        message,
      },
    });
  }
}
